export const inClientMode = () => {
  return typeof window !== 'undefined';
};

export const getEnvVariable = (key: string, fallback?: string) => {
  if (inClientMode()) {
    return (window as any)[key] ?? (import.meta.env as any)[key] ?? fallback;
  } else {
    return (import.meta.env as any)[key] ?? fallback;
  }
};
